module.exports = __webpack_public_path__ + "static/media/leaningTowerOfPisa.6bc54fbd.jpg";